var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMerLogoStor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 100,
    viewBox: "0 0 148 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V125H50V0Z",
    fill: "url(#paint0_linear_116_891)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 -20H49V173H99V-20Z",
    fill: "url(#paint1_linear_116_891)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148 -42H99V173H148V-42Z",
    fill: "url(#paint2_linear_116_891)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_116_891",
    x1: 25.011,
    y1: 5.58256,
    x2: 25.011,
    y2: 120.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1677,
    stopColor: "#0003C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3024,
    stopColor: "#010DCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4256,
    stopColor: "#021ECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5421,
    stopColor: "#0436D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6538,
    stopColor: "#0655D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762,
    stopColor: "#087BDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8672,
    stopColor: "#0BA7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9676,
    stopColor: "#0FDAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10ECEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_116_891",
    x1: 74.0321,
    y1: -11.3805,
    x2: 74.0321,
    y2: 166.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10ECEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_116_891",
    x1: 123.49,
    y1: -32.398,
    x2: 123.49,
    y2: 165.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0323756,
    stopColor: "#0112CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1328,
    stopColor: "#0545D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    stopColor: "#0871D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3462,
    stopColor: "#0A97DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4579,
    stopColor: "#0CB6E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5744,
    stopColor: "#0ECEE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6976,
    stopColor: "#0FDFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8323,
    stopColor: "#10E9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10ECEC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerLogoStor);
export default __webpack_public_path__ + "static/media/mer-logo-stor.c29c6144948d12f4ebe16e90e7a2e92b.svg";
export { ForwardRef as ReactComponent };